import { render, staticRenderFns } from "./batch-upload.vue?vue&type=template&id=5ef0b558&scoped=true"
import script from "./batch-upload.vue?vue&type=script&lang=js"
export * from "./batch-upload.vue?vue&type=script&lang=js"
import style0 from "./batch-upload.vue?vue&type=style&index=0&id=5ef0b558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef0b558",
  null
  
)

export default component.exports